import { render, staticRenderFns } from "./SeasonCard.vue?vue&type=template&id=20c01e05&scoped=true"
import script from "./SeasonCard.vue?vue&type=script&lang=js"
export * from "./SeasonCard.vue?vue&type=script&lang=js"
import style0 from "./SeasonCard.vue?vue&type=style&index=0&id=20c01e05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c01e05",
  null
  
)

export default component.exports